<template>
    <div :style="{backgroundColor:bgColor}" class="header-fixed">
        <el-row class="header-content" type="flex" justify="end">
            <el-col class="header-box">
                <ul>
                    <li v-if="vipType != '0'" @click="showVipHandler"><a>激活会员</a><span></span></li>
                    <li class="header-li"><a>{{ website.name ? website.name : '荔枝生涯' }}小程序</a><span></span></li>
                    <li class="header-code" style="margin-left: 60px">
                        <img src="../assets/images/xiaochengxu.jpg" alt="小程序">
                    </li>
                    <li class="header-li"><a>{{ website.name ? website.name : '荔枝生涯' }}公众号</a><span v-if="token"></span></li>
                    <li class="header-code">
                        <img src="../assets/images/code.jpg" alt="公众号">
                    </li>
                    <li class="header-li" v-if="token"><a>专属客服</a></li>
                    <li class="header-code" style="margin-left: 200px">
                        <img :src="$store.state.user.qr_pic" alt="专属客服">
                    </li>
                </ul>
            </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" align="middle" class="header-nav" :style="{backgroundColor:bgColor}">
            <div class="header-img">
                <img v-if="website.logo_top" :src="file_url + website.logo_top" alt="logo">
                <img v-else src="../assets/images/logo.png" alt="logo">
            </div>
            <div>
                <el-menu router :default-active="onRoutes"  mode="horizontal" class="menu-ul" :style="{backgroundColor:bgColor}">
                    <template v-for="(item,index) in menuList">
                        <el-menu-item v-if="item.id == '2' || item.id == '4'  || item.id == '5' || item.id == '8'" :index="item.path" @mouseenter.native="hoverMenuHandler(index)" @mouseleave.native="hoverMenuHandler(index)" @click="toolsLinkHandler(item)" :key="index">
                            <template>
                                {{item.menuName}}
                                <i class="el-icon-arrow-down" v-if="activeMenuIndex != index"></i>
                                <i class="el-icon-arrow-up" v-if="activeMenuIndex == index"></i>
                                <ul class="menu-tools-ul" v-if="hoverMenuStatus && activeMenuIndex == index">
                                    <div v-for="(child,childIndex) in item.children" :key="childIndex">
                                        <li class="menu-li" v-if="child.menuName" @click.stop>{{child.menuName}}</li>
                                        <li @click.stop="toolsLinkHandler(menu,item)" v-for="(menu,menuIndex) in child.children" :key="menuIndex">
                                            <template v-if="provinceCode === '13' && menu.hidden"></template>
                                            <template v-else>{{menu.menuName}}</template>
                                        </li>
                                    </div>
                                </ul>
                            </template>
                        </el-menu-item>
                        <template v-else-if="item.id == '6'">
                            <el-menu-item :index="item.path" :key="index">
                            <div>{{item.menuName}}</div>
                        </el-menu-item>
                        </template>
                        <el-menu-item v-else :index="item.path" :key="index">
                            {{item.menuName}}
                        </el-menu-item>
                    </template>
                </el-menu>
            </div>
            <div class="menu-right"> 
                <div class="menu-diff" :class="token?'menu-diff1':''" @click="linkToVip">
                    <img src="../assets/images/vip_icon.png" alt="开通VIP">
                    <div>开通VIP</div>
                </div>
                <div class="header-login" v-if="!token">
                    <!-- <el-image :src="head_img" alt="头像" fit="cover"></el-image> -->
                    <div class="header-link-list">
                        <a @click="loginHandler(true)">登录</a>/
                        <a @click="registerHandler(true)">注册</a>
                    </div>
                </div>
                <div class="header-login header-login-diff" @mouseenter="linkShowState(true)" @mouseleave="linkShowState(false)" v-else>
                    <el-image :src="head_img" alt="头像" fit="cover"></el-image>
                    <!-- <img src="../assets/images/vip.png" alt="会员" class="head-vip" v-if="vipType == '1'"> -->
                    <!-- <img src="../assets/images/svip.png" alt="会员" class="head-vip" v-else-if="vipType == '2'"> -->
                    <div class="header-link"><a>{{mobile.substring(0,3) + '****'+mobile.substring(7,11)}}</a></div>
                    <el-menu v-if="linkShow">
                    <!-- <el-menu> -->
                        <li @click="linkHandler">
                            <img src="../assets/images/gr.png" alt="个人中心" class="login-icon">
                            个人中心
                        </li>
                        <li style="color: #eb543b;" @click="loginOutHandler">
                            <img src="../assets/images/tc.png" alt="退出登录" class="login-icon">
                            退出登录
                        </li>
                    </el-menu>
                </div>
            </div>
        </el-row>
        <!-- <div v-if="isLogin">
            <Login></Login>
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
			linkShow: false,
            bgColor: '#ffffff',
            head_img: require('../assets/images/touxiang.png'),
            file_url: process.env.VUE_APP_FILE_API,
            menuList: [
                {
                    path: '/home',
                    menuName: '首页',
                    id:'1'
                },
                {
                    path: '/path1',
                    menuName: '志愿填报',
                    id:'2',
                    children:[
                        {
                            menuName: '智能评测',
                            children:[
                                {
                                    path: '/interest',
                                    menuName: '兴趣测试',
                                },
                                {
                                    path: '/character',
                                    menuName: '性格测试',
                                },
                                {
                                    path: '/goal',
                                    menuName: '学业目标测评',
                                },
                                {
                                    path: '/major',
                                    menuName: '专业信息',
                                },
                                {
                                    path: '/occupation',
                                    menuName: '职业信息'
                                },
                            ]
                        },
                        {
                            menuName: '信息查询',
                            children:[
                                {
                                    path: '/school',
                                    menuName: '院校信息',
                                },
                                {
                                    path: '/sameScore',
                                    menuName: '同分去向',
                                },
                                {
                                    path: '/rank',
                                    menuName: '院校排行',
                                },
                                {
                                    path: '/rankEvaluation',
                                    menuName: '全国学科评估',
                                },
                                {
                                    path: '/toolsRank',
                                    menuName: '批次位次查询',
                                },
                                {
                                    path: '/toolsAdvance',
                                    menuName: '提前批查询',
                                }
                                // {
                                //     path: '/toolsBatch',
                                //     menuName: '批次位次查询',
                                //     function_code: 'F00005'
                                // },
                                // {
                                //     path: '/toolsScore',
                                //     menuName: '艺术分转换',
                                // }
                            ]
                        },
                        {
                            menuName: '志愿填报',
                            children:[
                                {
                                    path: '/smartAspiration',
                                    menuName: '一键填报',
                                },
                                {
                                    path: '/zhiyuan',
                                    menuName: '志愿填报',
                                },
                                {
                                    path: '/probability',
                                    menuName: '录取概率测试',
                                    hidden: true
                                },
                                {
                                    path: '/toolsAdmission',
                                    menuName: '录取院校测试',
                                    hidden: true
                                },
                                {
                                    path: '/imitateAspiration',
                                    menuName: '模拟填报',
                                }
                            ]
                        }
                    ]
                    
                },
                {
                    path: '/newExamination',
                    // path: '/not_open',
                    menuName: '新高考',
                    id:'3'
                },
                {
                    path: '/path2',
                    menuName: '特殊类型招生',
                    id:'4',
                    children:[
                        {
                            menuName: '',
                            children:[
                                {
                                    path: '/valuation',
                                    menuName: '综合评价',
                                },
                                {
                                    path: '/basicPlan',
                                    menuName: '强基计划',
                                },
                                {
                                    path: '/specialPlan',
                                    menuName: '专项计划',
                                },
                                {
                                    path: '/sergeant',
                                    menuName: '定向培养士官',
                                },
                                {
                                    path: '/normalStudents',
                                    menuName: '公费师范生',
                                },
                                {
                                    path: '/highSchool',
                                    menuName: '高职单招',
                                },
                                {
                                    path: '/submitStudents',
                                    menuName: '保送生',
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/path3',
                    menuName: '艺考',
                    id:'5',
                    children:[
                        {
                            menuName: '',
                            children:[
                                {
                                    path: '/director',
                                    menuName: '编导',
                                },
                                {
                                    path: '/performance',
                                    menuName: '表演',
                                },
                                {
                                    path: '/broadcast',
                                    menuName: '播音主持',
                                },
                                {
                                    path: '/art',
                                    menuName: '美术',
                                },
                                {
                                    path: '/calligraphy',
                                    menuName: '书法',
                                },
                                {
                                    path: '/dance',
                                    menuName: '舞蹈',
                                },
                                {
                                    path: '/music',
                                    menuName: '音乐',
                                }
                            ]
                        }
                    ]
                },
                {
                    path: '/overseas',
                    // path: '/bus',
                    menuName: '留学',
                    id:'9'
                },
                {
                    path: '/upgrade',
                    // path: '/bus',
                    menuName: '专升本',
                    id:'6'
                },
                {
                    path: '/news',
                    menuName: '高考资讯',
                    id:'7'
                },
                {
                    path: '/path4',
                    menuName: '高考课堂',
                    id:'8',
                    children:[
                        {
                            menuName: '',
                            children:[
                                {
                                    path: '/video',
                                    menuName: '高考课堂',
                                },
                                {
                                    path: '/download',
                                    menuName: '资料下载',
                                },
                                {
                                    path: '/gkGuide',
                                    menuName: '高考百科',
                                }
                            ]
                        }
                    ]
                },
            ],
            keyWord:'',
            headers: {
                'x-auth-token': localStorage.getItem('token')  
            },
            hoverMenuStatus: false,
            activeMenuIndex: '',
        };
    },
    computed: {
        ...mapState({
            isLogin: state => state.user.isLogin,
			token: state => state.user.token,
            mobile: state => state.user.mobile,
            vipType: state => state.user.vipType,
            website: state => state.user.website,
            provinceCode: state => state.user.provinceCode,
            headImgHandler() {
                if(this.$store.state.user.head_img != 'null' && this.$store.state.user.head_img != '') {
                    this.head_img = this.$store.state.user.head_img;
                } else {
                    this.head_img = require('../assets/images/touxiang.png');
                }
                return this.$store.state.user.head_img;
            },
            
        }),
        onRoutes () {
            if(this.$route.path != '/search') {
                this.keyWord = '';
            }
            this.setColor();
            if (this.$route.path == '/zhiyuan' || this.$route.path == '/majorDetail' || this.$route.path == '/schoolDetail' || this.$route.path == '/schoolNewsDetail' || this.$route.path == '/singleNewsDetail' || this.$route.path == '/singleDetail' || this.$route.path == '/evaluationDetail' || this.$route.path == '/school' || this.$route.path == '/major' || this.$route.path == '/rank' || this.$route.path == '/toolsBatch' || this.$route.path == '/toolsRank' || this.$route.path == '/toolsScore' || this.$route.path == '/interest' || this.$route.path == '/character' || this.$route.path == '/rank' || this.$route.path == '/evaluationDetail' || this.$route.path == '/rankEvaluation' || this.$route.path == '/occupation' || this.$route.path == '/occupationDetail' || this.$route.path == '/toolsAdvance' || this.$route.path == '/smartAspiration' || this.$route.path == '/toolsAdmission' || this.$route.path == '/goal' || this.$route.path == '/sameScore' || this.$route.path == '/probability') {
                return '/path1'
            } else if (this.$route.path == '/schoolDetail' || this.$route.path == '/singleNewsDetail' || this.$route.path == '/singleDetail') {
                return '/school'
            } else if (this.$route.path == '/newsDetail' || this.$route.path == '/news') {
                return '/news'
            } else if (this.$route.path == '/querySubject') {
                return '/newExamination'
            }  else if (this.$route.path == '/valuation' || this.$route.path == '/specialPlan' || this.$route.path == '/sergeant' || this.$route.path == '/basicPlan' || this.$route.path == '/highSchool' || this.$route.path == '/normalStudents' || this.$route.path == '/submitStudents' || this.$route.path == '/recommendNewsDetail') {
                return '/path2'
            } else if (this.$route.path == '/director' || this.$route.path == '/performance' || this.$route.path == '/broadcast' || this.$route.path == '/art' || this.$route.path == '/calligraphy' || this.$route.path == '/dance' || this.$route.path == '/music') {
                return '/path3'
            } else if (this.$route.path == '/detail' || this.$route.path == '/person' || this.$route.path == '/orderDetail') {
                return '/home'
            } else if (this.$route.path == '/video' || this.$route.path == '/videoDetail' || this.$route.path == '/download' || this.$route.path == '/gkGuide' || this.$route.path == '/guideDetail') {
                return '/path4'
            } else {
                return this.$route.path
            }
        }
    },
    watch: {
        headImgHandler(newVal) {
            if(newVal != '') {
                this.head_img = newVal;
            } 
        },
        isLogin() {
            this.linkShow = false;
        }
    },
	mounted() {
		this.setColor();
        this.keyWord  = this.$route.query.keyWord;
        this.linkShow = false;
	},
    methods: {
        setColor() {
            if(this.$route.path == '/home') {
                this.bgColor = '#ffffff';
            } else {
                this.bgColor = '#ffffff';
            }
        },
        loginHandler(isLogin) {
            this.$store.commit("user/LOGINSTATUS",isLogin)
        },
        registerHandler(isRegister) {
            this.$store.commit('user/REGISTER', isRegister);
        },
		linkShowState(show) {
			this.linkShow = show;
		},
        linkHandler() {
            this.$router.push({
                path: '/person'
            })
        },
        searchHandler() {
            if(this.keyWord == '') {
                this.$message({
                    showClose: true,
                    message: '关键词不能为空',
                    type: 'error'
                });
            } else {
                this.$router.push({
                    path: '/search',
                    query: {
                        keyWord: this.keyWord
                    }
                })
            }
        },
        loginOutHandler() {
            this.$store.dispatch('user/LOGINOUT');
        },
        showVipHandler() {
            if(!this.$store.state.user.token) {
                this.$store.commit("user/LOGINSTATUS",true);
            } else {
                localStorage.setItem("isNewUser","false");
                this.$store.commit('user/SHOWADDVIP', true);
            }
        },
        // showProvinceHandler() {
        //     this.$store.commit('user/SHOWPROVINCE', true);
        // },
        hoverMenuHandler(index) {
            this.hoverMenuStatus = !this.hoverMenuStatus
            if(this.hoverMenuStatus) {
                this.activeMenuIndex = index
            } else {
                this.activeMenuIndex = ''
            }
        },
        toolsLinkHandler(menu,item) {
            this.$store.commit("user/LOGINSTATUS",false);
            if(!item || !item.path == '/') {
                return
            }
            if(menu.path === '/toolsBatch') {
                if(!this.$store.state.user.token) {
                    this.$store.commit('user/LOGINSTATUS', true);
                    return
                }
                // if(this.functionCodeList.indexOf(menu.function_code) === -1) {
                //     this.$message({
                //         showClose: true,
                //         message: '未开通此功能',
                //         type: 'warning'
                //     });
                //     return
                // }
            }
            this.$router.push({
                path: menu.path
            });
        },
        linkToVip() {
            if(!this.$store.state.user.token) {
                this.$store.commit('user/LOGINSTATUS', true);
                return
            }
            this.$router.push({
                path: "/vip"
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.header-content {
        background: #f5f1f0;
        padding: 0 4%;
	}
    .header-box {
        width: 100%;
        @include gflex;
        height: 32px;
		justify-content: flex-end;
        font-size: 12px;
        font-weight: 400;
        color: #999390;
        line-height: 32px;
        ul {
            margin: 0!important;
            padding: 0!important;
        }
        ul li {
            display: inline-block;
            span {
                border-left: 1px solid #ccc6c4;
                width: 1px;
                height: 14px;
                margin: 0 16px;
            }
            a{
                cursor: pointer;
            }
            img {
                width: 204px;
                height: 204px;
                background: #fff;
            }
        }
        .header-code {
            display: block;
            position: absolute;
            z-index: 9999;
            top: 40px;
            margin-left: 180px;
            display: none;
        }
        .header-li:hover+.header-code{
            display: block;
        }
    }
    // .header-search {
    //     @include gwidth;
    //     margin-top: 20px;
    //     .header-img {
    //         img {
    //             width: 134px;
    //             height: 40px;
    //         }
    //     }
        
    //     .search-img {
    //         img {
    //             width: 32px;
    //             height: 32px;
    //             margin-top: 3px;
    //         }
    //     }
    // }
    .header-nav {
        // @include gwidth;
        font-size: 16px;
        font-weight: 400;
        color: #5e6166;
        width: 100%;
        padding: 0 4%;
    }
    .header-img {
        img {
            // width: 134px;
            // height: 40px;
            width: 170px;
            height: 40px;
            margin-top: 8px;
        }
    }
    .menu-right {
        @include gflex;
        position: relative;
        flex: 0 0 170px;
        justify-content: flex-end;
        .menu-diff {
            margin-right: 24px;
            margin-top: 0px;
            text-align: center;
            cursor: pointer;
            div {
                color: #4b413b;
                font-size: 13px;
                margin-top: 2px;
            }
            div:hover {
                color: $common-color;
            }
            img {
                width: 30px;
                height: 30px;
            }
        }
        .menu-diff1 {
            position: relative;
            left: 32px;
        }
    }
    .header-login {
        // position: relative;
        // cursor:pointer;
        .header-link-list {
            margin-top: 9px;
            width: 83px;
            height: 34px;
            background: linear-gradient(90deg,#ff994a, $common-color);
            border-radius: 8px;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 34px;
        }
        a {
            cursor: pointer;
        }
        .header-link a:hover {
            color: $common-color;
        }
        .head-vip {
            width: 34px;
            height: 34px;
            position: absolute;
            right: 0;
        }
        .el-menu {
            width: 110px!important;
            background: #ffffff;
            border-radius: 6px;
            box-shadow: 0px 1px 6px 0px rgba(51,55,61,0.20); 
            padding: 8px 0;
            box-sizing: border-box;
            position: absolute;
            right: -32px;
            margin-top: 4px;
            z-index: 9999;
			-webkit-transition: -webkit-transform 0.1s
            cubic-bezier(0.165, 0.84, 0.44, 1);
			transition: transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
            li {
                color: #5e6166;
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                cursor: pointer;
                text-align: center;
                // padding-right: 12px;
            }
            li:hover {
                background: rgb(255,241,235);
            }
        }
        .login-icon {
            width: 14px;
            height: 14px;
            margin: 0;
            position: relative;
            top: 2px;
            border-radius: 0;
        }
    }
    .header-login-diff {
        text-align: right;
        position: relative;
        top: -1px;
        .el-image,img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
        }
        .header-link {
            position: relative;
            left: 30px;
            top: -2px;
        }
    }
    .menu-tools-ul {
        position: absolute;
        min-width: 112px;
        height: auto;
        padding: 14px 0;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0px 1px 6px 0px rgba(51,55,61,0.20); 
        z-index: 9999;
        color: #5e6166;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        left: -20px;
        top: 62px;
        margin-top: -8px;
        background: rgba(255,255,255,0.80);
        border-radius: 10px;
        box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.10); 
        backdrop-filter: blur(6px);
        @include gflex;
        .menu-li {
            color: #332e2c!important;
            font-size: 18px;
            font-weight: 600;
            cursor: default;
        }
        li {
            padding: 0 24px;
            list-style: none;
        }
        li:hover {
            color: $common-color;
        }
    }

</style>